import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import FifthWheelConnection from './fifth-wheel-connection';
import FifthWheelConnectionDetail from './fifth-wheel-connection-detail';
import FifthWheelConnectionUpdate from './fifth-wheel-connection-update';
import FifthWheelConnectionDeleteDialog from './fifth-wheel-connection-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FifthWheelConnectionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FifthWheelConnectionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FifthWheelConnectionDetail} />
      <ErrorBoundaryRoute path={match.url} component={FifthWheelConnection} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={FifthWheelConnectionDeleteDialog} />
  </>
);

export default Routes;
